import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import maxMessengerUrl from "./max-messenger.png";
export const MaxMessengerBrandIcon = ({ size = 20, color = "currentColor", }) => {
    const spanStyle = {
        display: "inline-block",
        flexShrink: 0,
        width: size,
        height: size,
        verticalAlign: "middle",
        backgroundColor: color,
        WebkitMaskImage: `url(${maxMessengerUrl})`,
        maskImage: `url(${maxMessengerUrl})`,
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskMode: "luminance",
        maskMode: "luminance",
    };
    return _jsx("span", { "aria-hidden": true, style: spanStyle });
};
